import { useEffect, useState } from 'react';
import useIsLoggedIn from '../account/useIsLoggedIn';
import useAppSelector from '../app/redux/useAppSelector';
import { UiThemeSetting } from '../graphql/generated/graphql';

const MATCH = '(prefers-color-scheme: dark)';

const getUiThemeByMatch = (): UiThemeSetting =>
  window?.matchMedia(MATCH).matches
    ? UiThemeSetting.Dark
    : UiThemeSetting.Light;

export const useUserUiTheme = () => {
  const isLoggedIn = useIsLoggedIn();
  const theme = useAppSelector((state) => state.session.user.settings?.uiTheme);

  const defaultTheme = isLoggedIn ? UiThemeSetting.Auto : null;

  return theme ?? defaultTheme;
};

const useUiTheme = (): UiThemeSetting => {
  const userTheme = useUserUiTheme();

  const [systemColor, setSystemColor] = useState<UiThemeSetting>(
    getUiThemeByMatch(),
  );

  useEffect(() => {
    const colorSchemeListener = () => {
      setSystemColor(getUiThemeByMatch());
    };

    colorSchemeListener();

    window?.matchMedia(MATCH).addEventListener('change', colorSchemeListener);

    return () =>
      window
        ?.matchMedia(MATCH)
        .removeEventListener('change', colorSchemeListener);
  }, [setSystemColor]);

  return !userTheme || userTheme === UiThemeSetting.Auto
    ? systemColor
    : userTheme;
};

export default useUiTheme;
